import React from 'react';
import { TrevorComponent } from '@trevor/ui-components';
import StepContent from '@/components/StepContent';
import { DimensionsReadOnlyMode } from '@/components/layers/LayerAggregate/subcomponents/DimensionsReadOnlyMode';
import { MetricsReadOnlyMode } from '@/components/layers/LayerAggregate/subcomponents/MetricsReadOnlyMode';
import AggregateFunction from '@/util/AggregateFunction';
import TableRef from '@/util/TableRef';
import ColumnName from '@/util/ColumnName';
import AggregateColumn from '@/util/AggregateColumn';

export type LayerAggregateReadOnlyModeProps = {
  functions: AggregateFunction[];
  aliases: Record<string, TableRef>;
  pks: ColumnName[];
  keys: AggregateColumn[];
  editLayerClicked: F0;
  layerId: number;
};

export const LayerAggregateReadOnlyMode: TrevorComponent<
  LayerAggregateReadOnlyModeProps
> = ({ functions, aliases, pks, keys, layerId, editLayerClicked }) => {
  return (
    <StepContent>
      <MetricsReadOnlyMode
        functions={functions}
        aliases={aliases}
        pks={pks}
        editLayerClicked={editLayerClicked}
        layerId={layerId}
      />
      <DimensionsReadOnlyMode
        keys={keys}
        aliases={aliases}
        pks={pks}
        editLayerClicked={editLayerClicked}
        layerId={layerId}
      />
    </StepContent>
  );
};
